module.exports = false;



//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1